import React from 'react';
import { Checkbox, CheckboxProps } from '@mui/material';

const CustomCheckbox: React.FC<CheckboxProps> = ({ ...props }) => {
  return (
    <Checkbox
      {...props}
      disableRipple
      sx={{
        color: 'var(--icon-disabled)',
        ...props.sx,
      }}
    />
  );
};

export default CustomCheckbox;
